export default "__VITE_ASSET__Bs5M2ymB__"